import { render, staticRenderFns } from "./chi-siamo.vue?vue&type=template&id=33e24d0f&scoped=true&"
import script from "./chi-siamo.vue?vue&type=script&lang=ts&"
export * from "./chi-siamo.vue?vue&type=script&lang=ts&"
import style0 from "./chi-siamo.vue?vue&type=style&index=0&id=33e24d0f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e24d0f",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsThePageTitleSection: require('/usr/src/nuxt-app/components/elements/ThePageTitleSection.vue').default})
